import Autocomplete from "@mui/material/Autocomplete";
import translations from "../../components/translations";
import { useLanguage } from "../../components/contexts/LanguageContext";
import { useEffect, useState } from "react";
import { OrganisationUnitsState } from "../../atoms/orgunitsState";
import { useRecoilValue } from "recoil";
import { useParams } from "../../hooks/common/useParams";
import { TextField } from "@mui/material";

interface CustomInputProps {
  onChange?: (arg1: any, arg2: any, arg3:any) => void;
}

export default function CustomInput(props: CustomInputProps) {
  const { onChange } = props;
  const { selectedLanguage } = useLanguage();
  const [inputValue, setInputValue] = useState("");
  const ous = useRecoilValue(OrganisationUnitsState)
  const [options, setOptions] = useState<{ value: any; label: any; code: any }[]>([]);
  const { useUrlParamiters } = useParams()
  const { orgUnitName } = useUrlParamiters()
  const [selectedOption, setSelectedOption] = useState<any | null>(null);



  useEffect(() => {
    if (ous)
      setOptions(formatOptions(ous?.ous) || [])
  }, [ous]);

  useEffect(() => {
    if(!selectedOption){

    }
  },[selectedOption])

  useEffect(() => {
    if (orgUnitName && options.length > 0) {
      const found = options.find(opt => opt.label.toLowerCase() === orgUnitName.toLowerCase());
      if (found) {
        setSelectedOption(found);
        setInputValue(found.label);
      }
    }
  }, [orgUnitName, options]);

  function formatOptions(data: any[]) {
    return data?.map((item) => ({ value: item?.id, label: item?.name, ...item }));
  }

  const handleChange = (e: any, newValue: any) => {
    if (onChange) {
      onChange(e, newValue,ous?.defaultOu);
    }
    setSelectedOption(newValue);
    setInputValue(newValue?.label || "");
  };

  return (
    <Autocomplete
      id="custom-input-demo"
      options={options}
      value={selectedOption}
      inputValue={inputValue}
      onChange={handleChange}
      onInputChange={(e, value) => setInputValue(value)}
      renderInput={(params) => (
        <TextField
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                border: 'none',
              },
              '&:hover fieldset': {
                border: 'none',
              },
              '&.Mui-focused fieldset': {
                border: 'none',
              },
            },
          }}
          type="text"
          {...params}
          name="query"
          value={inputValue}
          // {...params.inputProps}
          className="form-control my-field"
          placeholder={translations[selectedLanguage].searchPlaceholder}
        />
      )}
    />
  )
}
